export default "__VITE_ASSET__DtCQxR$r__"